import { render, staticRenderFns } from "./units.vue?vue&type=template&id=1e35c3a5&"
import script from "./units.vue?vue&type=script&lang=ts&"
export * from "./units.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/forge/aef.slmndr.be/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('1e35c3a5')) {
      api.createRecord('1e35c3a5', component.options)
    } else {
      api.reload('1e35c3a5', component.options)
    }
    module.hot.accept("./units.vue?vue&type=template&id=1e35c3a5&", function () {
      api.rerender('1e35c3a5', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/js/components/projects/units.vue"
export default component.exports